import Rating from "../Rating/Rating";
import styles from "./RatingComponent.module.scss";
interface RatingComponentProps {
  label: string | JSX.Element;
  renderDirection?: "row" | "column";
}
function RatingComponent(props: RatingComponentProps) {
  const { label, renderDirection = "column" } = props;
  return (
    <div
      className={`start-1 col-4 ${styles.RatingComponentWrapper} ${
        renderDirection === "column"
          ? styles.renderInColumn
          : styles.renderInRow
      }`}
    >
      {typeof label === "string" ? (
        <p className={`title-medium ${styles.RatingComponentLabel}`}>{label}</p>
      ) : (
        label
      )}
      <Rating />
    </div>
  );
}
export default RatingComponent;
